import { MobileTitle } from '../../components/Title'
// import { Tweet, Timeline } from 'react-twitter-widgets'
export const Contest = () => {
    return (
        <>
            {' '}
            <MobileTitle title='Contest' />
            <div className='px-4 max-w-[1200px] mx-auto'>
                <div className='flex justify-center mt-8'>
                    <img
                        className=''
                        alt='gameflow button'
                        src={`${process.env.PUBLIC_URL}/images/contest/contest-header-retweet.png`}
                    />
                </div>{' '}
                <p className='text-shadow-white text-pbnavy font-kiwi font-bold text-sub md:text-base mx-auto text-center w-4/5 mt-12'>
                    One lucky winner will be selected to win a limited exclusive prize featuring
                    <span className='text-pborange'> Phantom Brave: The Lost Hero Key Art by Takehito Harada</span>
                </p>
                <div className='flex flex-col md:flex-col justify-center my-4 md:mb-20 md:mt-12 gap-16'>
                    <div className='w-3/5 mx-auto md:w-full'>
                        <img
                            className='w-full mx-auto max-w-[380px]'
                            alt='gameflow button'
                            src={`${process.env.PUBLIC_URL}/images/contest/prize.jpg`}
                        />{' '}
                    </div>{' '}
                    <div className='w-full mx-auto md:w-4/5'>
                        <div className='font-kiwi font-bold text-sub md:text-sm mx-auto '>
                            <h3 className='text-center text-gradient-title text-lg font-pop'>Contest Period </h3>{' '}
                            <p className='text-shadow-white text-pbnavy my-8 text-center'>
                                June 27, 2024 (9:00am PDT) - July 7, 2024 (11:59pm PDT)
                            </p>
                        </div>{' '}
                        <div className='font-kiwi font-bold text-sub md:text-sm mx-auto '>
                            <h3 className='text-center text-gradient-title text-lg font-pop'>How to Enter</h3>{' '}
                            <div className='flex flex-col md:flex-row  mt-8'>
                                <div className='w-full'>
                                    <ol className='text-shadow-white text-pbnavy  pl-6 w-full list-decimal list-outside'>
                                        <li>
                                            <p>Retweet our tweet on X announcing Phantom Brave: The Lost Hero</p>
                                            <div className='w-full  mt-4 mx-auto'></div>
                                        </li>
                                        <li>
                                            <p>
                                                To be eligible to win, you must be following{' '}
                                                <a
                                                    className='text-blue-400 cursor-pointer'
                                                    href='https://twitter.com/NISAmerica'
                                                >
                                                    @NISAmerica
                                                </a>{' '}
                                            </p>
                                        </li>
                                    </ol>{' '}
                                </div>{' '}
                               
                                {/* <div className='w-full'>
                                    <Tweet
                                        tweetId='1806311520306876890'
                                        options={{
                                            // theme: 'dark',

                                            align: 'center',
                                            width: '400',
                                            chrome: 'noheader, nofooter, , noborders',
                                            nofooter: 'true',
                                            noborders: 'true',
                                        }}
                                    />
                                </div> */}
                            </div>
                        </div>{' '}
                        <div className=' font-kiwi font-bold text-sub md:text-sm mx-auto mt-12'>
                            <h3 className='text-center text-gradient-title text-lg font-pop'>Entry Eligibility</h3>{' '}
                            <ul className='text-shadow-white text-pbnavy pl-6 w-full list-disc list-outside mt-8'>
                                <li>
                                    <p>
                                        Open only to individuals who are legal residents of the fifty (50) United States
                                        (including the District of Columbia) and Canada (excluding Quebec) and are 18
                                        years of age or older.
                                    </p>
                                </li>
                            </ul>
                        </div>{' '}
                        <div className=' text-pbnavy font-kiwi font-bold text-sub md:text-sm mx-auto mt-12'>
                            <div className='font-kiwi font-bold text-sub md:text-sm mx-auto mt-12'>
                                <h3 className='text-center text-gradient-title text-lg font-pop'>Notifying a Winner</h3>{' '}
                                <ul className='text-shadow-white text-pbnavy pl-6 w-full list-disc list-outside mt-8'>
                                    <li>
                                        <p>
                                            Winners will be selected through a random drawing among all eligible entries
                                        </p>
                                    </li>
                                    <li>
                                        <p>
                                            Winners will be notified by 7/14 via direct message on X. Please ensure your
                                            account is set to receive direct messages.
                                        </p>
                                    </li>{' '}
                                    <li>
                                        <p>
                                            Winners shall have 7 days to claim their prize. If unclaimed, they will
                                            forfeit their prize and another winner shall be randomly selected
                                        </p>
                                    </li>{' '}
                                    <li>
                                        <p>
                                            Please view{' '}
                                            <a
                                                className='text-blue-400 cursor-pointer'
                                                href='https://www.nisamerica.com/contests'
                                            >
                                                here
                                            </a>{' '}
                                            for the complete list of contest rules and regulations'
                                        </p>
                                    </li>
                                </ul>
                            </div>{' '}
                        </div>
                    </div>
                </div>{' '}
            </div>
        </>
    )
}
